export type LandingTheme = {
  name: string;
  primary: string;
  secondary: string;
  background: string;
  accent: string;
  textOnPrimary: string;
  gradient: string;
};

export const themes: Record<string, LandingTheme> = {
  moda: {
    name: "Moda",
    primary: "338 100% 58%", // #ff2aad
    secondary: "0 0% 4%", // #0a0a0a
    background: "0 0% 100%", // #ffffff
    accent: "330 100% 91%", // #ffd5ec
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(338 100% 58%) 0%, hsl(280 100% 60%) 100%)",
  },
  beleza: {
    name: "Beleza & Estética",
    primary: "181 73% 46%", // #20c5c9
    secondary: "40 50% 59%", // #d4a857
    background: "0 0% 100%", // #ffffff
    accent: "180 50% 97%", // #f3fbfd
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(181 73% 46%) 0%, hsl(160 60% 50%) 100%)",
  },
  servicos: {
    name: "Serviços",
    primary: "156 61% 15%", // #0f3d2e
    secondary: "0 0% 85%", // #d9d9d9
    background: "0 0% 100%", // #ffffff
    accent: "0 0% 96%", // #f5f5f5
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(156 61% 15%) 0%, hsl(156 50% 25%) 100%)",
  },
  marketing: {
    name: "Marketing",
    primary: "270 100% 59%", // #9b2cff
    secondary: "0 0% 6%", // #0f0f0f
    background: "0 0% 100%", // #ffffff
    accent: "270 100% 95%", // #f4e8ff
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(270 100% 59%) 0%, hsl(300 100% 50%) 100%)",
  },
  academia: {
    name: "Academia & Fitness",
    primary: "25 95% 53%", // #f97316
    secondary: "0 0% 8%",
    background: "0 0% 100%",
    accent: "25 100% 95%",
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(25 95% 53%) 0%, hsl(0 80% 55%) 100%)",
  },
  imobiliaria: {
    name: "Imobiliária",
    primary: "230 70% 55%", // #4361ee
    secondary: "0 0% 10%",
    background: "0 0% 100%",
    accent: "230 100% 95%",
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(230 70% 55%) 0%, hsl(260 80% 60%) 100%)",
  },
  clinica: {
    name: "Clínica & Saúde",
    primary: "160 84% 39%", // #10b981
    secondary: "0 0% 8%",
    background: "0 0% 100%",
    accent: "160 80% 95%",
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(160 84% 39%) 0%, hsl(180 70% 45%) 100%)",
  },
  contabilidade: {
    name: "Contabilidade",
    primary: "220 15% 45%", // #64748b
    secondary: "0 0% 10%",
    background: "0 0% 100%",
    accent: "220 15% 95%",
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(220 15% 45%) 0%, hsl(220 20% 35%) 100%)",
  },
  alimentacao: {
    name: "Alimentação & Delivery",
    primary: "30 90% 50%", // #f59e0b
    secondary: "0 0% 8%",
    background: "0 0% 100%",
    accent: "30 100% 95%",
    textOnPrimary: "0 0% 100%",
    gradient: "linear-gradient(135deg, hsl(30 90% 50%) 0%, hsl(0 80% 55%) 100%)",
  },
};
